import { features } from '@kdcloudjs/table';

function useAutoRowSpan(pipeline, autoRowSpan) {
  if (autoRowSpan) {
    pipeline.use(features.autoRowSpan());
  }
}

export default useAutoRowSpan;